document.addEventListener("DOMContentLoaded", () => {

  const mainImage = document.getElementById("mainProductImage");
  const thumbs = document.querySelectorAll(".thumb-img");

  let currentIndex = 0;

  function updateImage(index) {
      const selected = thumbs[index];
      const imgUrl = selected.getAttribute("data-full");
      mainImage.src = imgUrl;

      thumbs.forEach(t => t.classList.remove("active-thumb"));
      selected.classList.add("active-thumb");

      currentIndex = index;
  }

  // Thumbnail click → update image
  thumbs.forEach((thumb, idx) => {
      thumb.addEventListener("click", () => updateImage(idx));
  });

  // ARROWS
  const btnPrev = document.getElementById("galleryPrev");
  const btnNext = document.getElementById("galleryNext");
  const thumbRow = document.querySelector(".thumbnail-row");

  btnPrev.addEventListener("click", () => {
      if (currentIndex > 0) {
          updateImage(currentIndex - 1);
          thumbRow.scrollTo({
              left: thumbs[currentIndex].offsetLeft - 50,
              behavior: "smooth"
          });
      }
  });

  btnNext.addEventListener("click", () => {
      if (currentIndex < thumbs.length - 1) {
          updateImage(currentIndex + 1);
          thumbRow.scrollTo({
              left: thumbs[currentIndex].offsetLeft - 50,
              behavior: "smooth"
          });
      }
  });

});

document.addEventListener('DOMContentLoaded', function () {

  const sizeButtons = document.querySelectorAll('.size-btn');
  const selectedSizeLabel = document.getElementById('selectedSize');
  const variantData = JSON.parse(document.getElementById('variantData').textContent);
  const variantInput = document.getElementById('selectedVariantId');

  sizeButtons.forEach(btn => {
    btn.addEventListener('click', function () {

      // Remove active class
      sizeButtons.forEach(b => b.classList.remove('active-size'));

      // Activate clicked size
      this.classList.add('active-size');

      // Update printed text
      const selectedSize = this.textContent.trim();
      selectedSizeLabel.textContent = selectedSize;

      // Find matching variant 
      // (Assuming Size is OPTION2 → change to option1 if needed)
      const matchedVariant = variantData.find(variant => {
        return variant.option2 === selectedSize;
      });

      // Update hidden variant ID
      if (matchedVariant) {
        variantInput.value = matchedVariant.id;
      }
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('openSizeChart');
  const closeBtn = document.getElementById('closeSizeChart');
  const modal = document.getElementById('sizeChartModal');

  openBtn?.addEventListener('click', () => {
    modal.style.display = 'flex';
  });

  closeBtn?.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  modal?.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });
});

(function () {
  // parse variant JSON
  const variants = JSON.parse(document.getElementById('variantData').textContent || '[]');

  // DOM nodes
  const selectedVariantInput = document.getElementById('selectedVariantId');
  const addBtn = document.getElementById('addToCartBtn');
  const checkoutBtn = document.getElementById('checkoutBtn');
  const outOfStockText = document.getElementById('outOfStockText');

  // helper: show/hide buttons based on availability
  function updateButtonsForVariant(variant) {
    if (!variant) return;

    const available = !!variant.available;

    if (available) {
      // show form/buttons
      if (outOfStockText) outOfStockText.style.display = 'none';
      if (addBtn) addBtn.disabled = false;
      if (addBtn) addBtn.style.display = '';
      if (checkoutBtn) checkoutBtn.style.display = '';
    } else {
      // hide form/buttons
      if (outOfStockText) outOfStockText.style.display = '';
      if (addBtn) addBtn.disabled = true;
      if (addBtn) addBtn.style.display = 'none';
      if (checkoutBtn) checkoutBtn.style.display = 'none';
    }
  }

  // find variant by id
  function findVariantById(id) {
    return variants.find(v => String(v.id) === String(id));
  }

  // update current variant by id (set input, toggle UI)
  function setVariantById(id) {
    if (!id) return;
    // set hidden input
    if (selectedVariantInput) selectedVariantInput.value = id;
    const v = findVariantById(id);
    updateButtonsForVariant(v);
  }

  // INITIAL: ensure UI matches initial server-side variant
  (function init() {
    // use value from hidden input (was set server-side)
    if (selectedVariantInput && selectedVariantInput.value) {
      setVariantById(selectedVariantInput.value);
    }
  })();

  // 1) Listen to native select[name="id"] (Shopify default variant selector)
  const nativeSelect = document.querySelector('select[name="id"]');
  if (nativeSelect) {
    nativeSelect.addEventListener('change', function (e) {
      const id = e.target.value;
      setVariantById(id);
      // also update hidden input (redundant if nativeSelect is the actual form input)
      if (selectedVariantInput) selectedVariantInput.value = id;
    });
  }

  // 2) Support custom variant buttons (common pattern: .size-btn, .color-swatch)
  //    Buttons should set a data-variant-id attribute when selected (we'll try to detect)
  // If your theme toggles .active-size or similar, we watch clicks on those elements.
  const variantButtons = document.querySelectorAll('.size-btn, .color-swatch, [data-variant-id]');
  if (variantButtons.length) {
    variantButtons.forEach(btn => {
      btn.addEventListener('click', function (e) {
        // if button has data-variant-id, use it
        const vid = btn.getAttribute('data-variant-id') || btn.dataset.variantId;
        if (vid) {
          setVariantById(vid);
          return;
        }

        // Otherwise try to infer option selection from UI text:
        // Build options map from the product variants and the selected option values on page.
        // This fallback attempts to read values from DOM for option selects/buttons.
        const chosenOptions = [];
        // try reading option selects: select[name^="option"]
        document.querySelectorAll('[name^="option"], select.product-option, .variant-option-select').forEach(optEl => {
          if (optEl.tagName.toLowerCase() === 'select') {
            chosenOptions.push(optEl.value);
          } else {
            chosenOptions.push(optEl.textContent.trim());
          }
        });
        // as last resort, include clicked button text
        chosenOptions.push(btn.textContent.trim());

        // find variant that matches chosenOptions (partial matching)
        const match = variants.find(v => {
          return chosenOptions.every((opt, i) => {
            // v.option1/2/3 exist as v.option1, v.option2...
            const optKey = 'option' + (i+1);
            return String(v[optKey]).toLowerCase() === String(opt).toLowerCase();
          });
        });
        if (match) setVariantById(match.id);
      });
    });
  }

  // 3) Observe changes to any variant input that might be present (for dynamic themes)
  // If the theme updates a hidden select or input, we'll pick it up.
  const observer = new MutationObserver(function () {
    const currentVal = selectedVariantInput && selectedVariantInput.value;
    if (currentVal) {
      const v = findVariantById(currentVal);
      updateButtonsForVariant(v);
    }
  });
  if (selectedVariantInput) {
    observer.observe(selectedVariantInput, { attributes: true, attributeFilter: ['value'], childList: false });
  }

  // Accessibility: if the hidden input changes programmatically elsewhere, reflect UI.
  document.addEventListener('variant:change', function (e) {
    // custom event support
    if (e?.detail?.id) setVariantById(e.detail.id);
  });

})();

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 525) {
    const el = document.querySelector(".gallery-action-wrapper");
    if (el) el.remove();
  }
});